import { prefix } from '../../../constants'

export const prefixTranslation = `${prefix}.actions`
